import { PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './well-section-wrap.style';

const WellSectionWrap = ({ children }: PropsWithChildren) => {
  const styles = componentStyles();

  return <Box style={styles.wrapper}>{children}</Box>;
};

export default WellSectionWrap;
